/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { riskApprovalsDecide } from "../funcs/riskApprovalsDecide.js";
import { riskApprovalsGet } from "../funcs/riskApprovalsGet.js";
import { riskApprovalsList } from "../funcs/riskApprovalsList.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { ListRiskPolicyApprovalsResult } from "../models/components/listriskpolicyapprovalsresult.js";
import { RiskPolicyApproval } from "../models/components/riskpolicyapproval.js";
import {
  DecideRiskPolicyApprovalRequest,
  DecideRiskPolicyApprovalSecurity,
} from "../models/operations/decideriskpolicyapproval.js";
import {
  GetRiskPolicyApprovalRequest,
  GetRiskPolicyApprovalSecurity,
} from "../models/operations/getriskpolicyapproval.js";
import {
  ListRiskPolicyApprovalsRequest,
  ListRiskPolicyApprovalsSecurity,
} from "../models/operations/listriskpolicyapprovals.js";
import { unwrapAsync } from "../types/fp.js";

export class Approvals extends ClientSDK {
  /**
   * decideRiskPolicyApproval risk
   *
   * @remarks
   * Approve or deny a pending tool approval request. Only a listed approver may decide, and never the person who made the call. An approval releases one retry of the exact call.
   */
  async decide(
    request: DecideRiskPolicyApprovalRequest,
    security?: DecideRiskPolicyApprovalSecurity | undefined,
    options?: RequestOptions,
  ): Promise<RiskPolicyApproval> {
    return unwrapAsync(riskApprovalsDecide(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getRiskPolicyApproval risk
   *
   * @remarks
   * Get one tool approval request, including a preview of the call's arguments.
   */
  async get(
    request: GetRiskPolicyApprovalRequest,
    security?: GetRiskPolicyApprovalSecurity | undefined,
    options?: RequestOptions,
  ): Promise<RiskPolicyApproval> {
    return unwrapAsync(riskApprovalsGet(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listRiskPolicyApprovals risk
   *
   * @remarks
   * List tool approval requests held by require_approval policies, newest first. Org admins see every request; others see requests they can approve and their own.
   */
  async list(
    request?: ListRiskPolicyApprovalsRequest | undefined,
    security?: ListRiskPolicyApprovalsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListRiskPolicyApprovalsResult> {
    return unwrapAsync(riskApprovalsList(
      this,
      request,
      security,
      options,
    ));
  }
}
